export const SidepanelHeight = '100%';
export const SidepanelWidth = '1000px';
export const SidepanelPosition = { right: '0' };

export const SIDEPANEL_MIN_WIDTH = 1000;
export const SIDEPANEL_MAX_WIDTH = 2000;
export const SIDEPANEL_MAX_VW = 90;
export const SIDEPANEL_STORAGE_KEY = 'sidepanel-width';
export const SIDEPANEL_STACKED_OFFSET = 50;
